import { createSlice } from '@reduxjs/toolkit';

/**
 * Grid 전역 상태 관리
 * state = {
 *   grid1: {
 *     rowData: [],   // 전체 데이터
 *     selected: [],  // 선택된 행들
 *     changed: [],   // 수정된 행들
 *     deleted: [],   // 삭제된 행들
 *   },
 *   grid2: { ... } // 그리드 상태값 추가로 필요 시 추가
 * }
 *
 * 사용법:     const gridState1 = useSelector((state) => state.grid.grid1);
 *       예시) const selectedRod = gridState1.selected
 * - setRowData: gridId별 rowData 설정
 *   dispatch(setRowData({ gridId: 'grid1', rowData }));
 * - setSelected: gridId별 선택된 행 배열 설정
 *   dispatch(setSelected({ gridId: 'grid2', selected }));
 * - setChanged: gridId별 수정된 행 배열 설정
 *   dispatch(setChanged({ gridId: 'grid1', changed }));
 * - setDeleted: gridId별 삭제된 행 배열 설정
 *     dispatch(setDeleted({ gridId: 'grid2', deleted }));
 */

const initialState = {
  grid1: {
    rowData: [],
    selected: [],
    changed: [],
    deleted: [],
  },
  // 그리드 상태값 추가로 필요 시 추가
  grid2: {
    rowData: [],
    selected: [],
    changed: [],
    deleted: [],
  },
};

const gridSlice = createSlice({
  name: 'grid',
  initialState,
  reducers: {
    setRowData: (state, action) => {
      const { gridId, rowData } = action.payload;
      if (state[gridId]) {
        state[gridId].rowData = rowData;
      }
    },
    setSelected: (state, action) => {
      const { gridId, selected } = action.payload;
      if (state[gridId]) {
        state[gridId].selected = selected;
      }
    },
    setChanged: (state, action) => {
      const { gridId, changed } = action.payload;
      if (state[gridId]) {
        state[gridId].changed = Array.isArray(changed) ? changed : [];
      }
    },
    setDeleted: (state, action) => {
      const { gridId, deleted } = action.payload;
      if (state[gridId]) {
        state[gridId].deleted = deleted;
      }
    },
    resetGrid(state) {
      // 상태를 초기값으로 리셋
      return initialState;
    },
  },
});

export const { setRowData, setSelected, setChanged, setDeleted, resetGrid } =
  gridSlice.actions;

export default gridSlice.reducer;
